// extracted by mini-css-extract-plugin
module.exports = {"ripple":"ripple-icon_ripple__j9vQl","badge":"ripple-icon_badge__PJqoE","icon":"ripple-icon_icon__Jv0sf"};